import { ExternalLink } from 'lucide-react';
import type { ProviderStepsProps } from './types';

export function ProviderSteps({ steps, link }: ProviderStepsProps) {
  return (
    <div className="flex flex-col gap-3">
      <ol className="flex list-decimal flex-col gap-1 pl-5 text-sm text-text-tertiary">
        {steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
      {link ? (
        <a
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex w-fit items-center gap-1.5 text-sm text-text-secondary underline underline-offset-4 hover:text-text-primary focus-visible:outline-none"
        >
          {link.label}
          <ExternalLink className="size-4" aria-hidden="true" />
        </a>
      ) : null}
    </div>
  );
}
